/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/history_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1ListActorHistoryResponse } from '../models'
// @ts-ignore
import { V1ListEntityHistoryResponse } from '../models'
/**
 * HistoryServiceApi - axios parameter creator
 * @export
 */
export const HistoryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary ListActorHistory — история действий пользователя (админ/аудит-вью).
     * @param {string} actorId
     * @param {string} [entityType] optional filter
     * @param {string} [action] optional filter
     * @param {string} [from]
     * @param {string} [to]
     * @param {string} [cursor]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    historyServiceListActorHistory: async (
      actorId: string,
      entityType?: string,
      action?: string,
      from?: string,
      to?: string,
      cursor?: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'actorId' is not null or undefined
      assertParamExists('historyServiceListActorHistory', 'actorId', actorId)
      const localVarPath = `/api/v1/history/actors/{actorId}`.replace(
        `{${'actorId'}}`,
        encodeURIComponent(String(actorId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (entityType !== undefined) {
        localVarQueryParameter['entityType'] = entityType
      }

      if (action !== undefined) {
        localVarQueryParameter['action'] = action
      }

      if (from !== undefined) {
        localVarQueryParameter['from'] =
          (from as any) instanceof Date ? (from as any).toISOString() : from
      }

      if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any) instanceof Date ? (to as any).toISOString() : to
      }

      if (cursor !== undefined) {
        localVarQueryParameter['cursor'] = cursor
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListEntityHistory — история одной сущности (карточка клиента/сделки).
     * @param {string} entityType
     * @param {string} entityId
     * @param {string} [action] optional filter
     * @param {string} [actorId] optional filter
     * @param {string} [from]
     * @param {string} [to]
     * @param {string} [cursor] keyset: opaque last id
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    historyServiceListEntityHistory: async (
      entityType: string,
      entityId: string,
      action?: string,
      actorId?: string,
      from?: string,
      to?: string,
      cursor?: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityType' is not null or undefined
      assertParamExists('historyServiceListEntityHistory', 'entityType', entityType)
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('historyServiceListEntityHistory', 'entityId', entityId)
      const localVarPath = `/api/v1/history/{entityType}/{entityId}`
        .replace(`{${'entityType'}}`, encodeURIComponent(String(entityType)))
        .replace(`{${'entityId'}}`, encodeURIComponent(String(entityId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (action !== undefined) {
        localVarQueryParameter['action'] = action
      }

      if (actorId !== undefined) {
        localVarQueryParameter['actorId'] = actorId
      }

      if (from !== undefined) {
        localVarQueryParameter['from'] =
          (from as any) instanceof Date ? (from as any).toISOString() : from
      }

      if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any) instanceof Date ? (to as any).toISOString() : to
      }

      if (cursor !== undefined) {
        localVarQueryParameter['cursor'] = cursor
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * HistoryServiceApi - functional programming interface
 * @export
 */
export const HistoryServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HistoryServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary ListActorHistory — история действий пользователя (админ/аудит-вью).
     * @param {string} actorId
     * @param {string} [entityType] optional filter
     * @param {string} [action] optional filter
     * @param {string} [from]
     * @param {string} [to]
     * @param {string} [cursor]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async historyServiceListActorHistory(
      actorId: string,
      entityType?: string,
      action?: string,
      from?: string,
      to?: string,
      cursor?: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListActorHistoryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.historyServiceListActorHistory(
        actorId,
        entityType,
        action,
        from,
        to,
        cursor,
        limit,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HistoryServiceApi.historyServiceListActorHistory']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListEntityHistory — история одной сущности (карточка клиента/сделки).
     * @param {string} entityType
     * @param {string} entityId
     * @param {string} [action] optional filter
     * @param {string} [actorId] optional filter
     * @param {string} [from]
     * @param {string} [to]
     * @param {string} [cursor] keyset: opaque last id
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async historyServiceListEntityHistory(
      entityType: string,
      entityId: string,
      action?: string,
      actorId?: string,
      from?: string,
      to?: string,
      cursor?: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListEntityHistoryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.historyServiceListEntityHistory(
        entityType,
        entityId,
        action,
        actorId,
        from,
        to,
        cursor,
        limit,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HistoryServiceApi.historyServiceListEntityHistory']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * HistoryServiceApi - factory interface
 * @export
 */
export const HistoryServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = HistoryServiceApiFp(configuration)
  return {
    /**
     *
     * @summary ListActorHistory — история действий пользователя (админ/аудит-вью).
     * @param {string} actorId
     * @param {string} [entityType] optional filter
     * @param {string} [action] optional filter
     * @param {string} [from]
     * @param {string} [to]
     * @param {string} [cursor]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    historyServiceListActorHistory(
      actorId: string,
      entityType?: string,
      action?: string,
      from?: string,
      to?: string,
      cursor?: string,
      limit?: number,
      options?: any,
    ): AxiosPromise<V1ListActorHistoryResponse> {
      return localVarFp
        .historyServiceListActorHistory(
          actorId,
          entityType,
          action,
          from,
          to,
          cursor,
          limit,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListEntityHistory — история одной сущности (карточка клиента/сделки).
     * @param {string} entityType
     * @param {string} entityId
     * @param {string} [action] optional filter
     * @param {string} [actorId] optional filter
     * @param {string} [from]
     * @param {string} [to]
     * @param {string} [cursor] keyset: opaque last id
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    historyServiceListEntityHistory(
      entityType: string,
      entityId: string,
      action?: string,
      actorId?: string,
      from?: string,
      to?: string,
      cursor?: string,
      limit?: number,
      options?: any,
    ): AxiosPromise<V1ListEntityHistoryResponse> {
      return localVarFp
        .historyServiceListEntityHistory(
          entityType,
          entityId,
          action,
          actorId,
          from,
          to,
          cursor,
          limit,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * HistoryServiceApi - object-oriented interface
 * @export
 * @class HistoryServiceApi
 * @extends {BaseAPI}
 */
export class HistoryServiceApi extends BaseAPI {
  /**
   *
   * @summary ListActorHistory — история действий пользователя (админ/аудит-вью).
   * @param {string} actorId
   * @param {string} [entityType] optional filter
   * @param {string} [action] optional filter
   * @param {string} [from]
   * @param {string} [to]
   * @param {string} [cursor]
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HistoryServiceApi
   */
  public historyServiceListActorHistory(
    actorId: string,
    entityType?: string,
    action?: string,
    from?: string,
    to?: string,
    cursor?: string,
    limit?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return HistoryServiceApiFp(this.configuration)
      .historyServiceListActorHistory(actorId, entityType, action, from, to, cursor, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListEntityHistory — история одной сущности (карточка клиента/сделки).
   * @param {string} entityType
   * @param {string} entityId
   * @param {string} [action] optional filter
   * @param {string} [actorId] optional filter
   * @param {string} [from]
   * @param {string} [to]
   * @param {string} [cursor] keyset: opaque last id
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HistoryServiceApi
   */
  public historyServiceListEntityHistory(
    entityType: string,
    entityId: string,
    action?: string,
    actorId?: string,
    from?: string,
    to?: string,
    cursor?: string,
    limit?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return HistoryServiceApiFp(this.configuration)
      .historyServiceListEntityHistory(
        entityType,
        entityId,
        action,
        actorId,
        from,
        to,
        cursor,
        limit,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}
